import LongText from '../Elements/LongText';
import React from 'react';

export default class TpProjectChangeItem {
  constructor(item) {
    if (item) {
      this.ProjectId = item.projectId;
      this.ProjectName = item.projectName;
      this.ServiceType = item.serviceType;
      this.StartDate = item.startDate;
      this.EndDate = item.endDate;
      return;
    }
    this.CfId = '';
    this.CfName = '';
    this.ServiceType = '';
    this.StartDate = '';
    this.EndDate = '';
  }

  static DateFields = ['StartDate', 'EndDate'];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: TpProjectChangeItem.getSelectedCellContent, minWidth: 20 },
      { label: 'Project ID', orderById: 'ProjectId', data: 'ProjectId' },
      { label: 'Project', orderById: 'ProjectName', data: (item) => <LongText text={item.ProjectName} maxLength={30} /> },
      { label: 'Start On', orderById: 'StartDate', data: 'StartDate' },
      { label: 'End On', orderById: 'EndDate', data: 'EndDate' },
      {
        label: 'Service Type',
        orderById: 'ServiceType',
        data: (item) => <LongText text={item.ServiceType} maxLength={30} />
      }
    ];
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            TpProjectChangeItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}
